import _ from "lodash";
import { Modal, notification } from "antd";
import React, { useEffect, useState } from "react";

import { InboxOutlined } from "@ant-design/icons";

import { Form, Input, Button, Radio, Upload, message } from "antd";
import { useGlobalStore } from "../../../../stores/globalBackendStore";
import parseMediaUrl from "../../functions/parseMediaUrl";
import { uploadMedia } from "../../../../services/backend/api.service";
import { useTranslation } from "react-i18next";

const { Dragger } = Upload;

const validateMessages = {
  required: "'${name}' is required!",
  // ...
};

export default (props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const apiSetup = useGlobalStore((state) => state.apiSetup);

  const {
    id,
    visibleEdit,
    setVisibleEdit,
    editData,
    setEditData,
    setRefreshData,
    accept,
    onUploadNew,
  } = props;

  const [confirmLoading, setConfirmLoading] = useState(false);

  const [file, setFile] = useState({
    uid: editData.uuid,
    name: editData.label,
    status: "done",
    url: parseMediaUrl(editData.url),
    thumbUrl: parseMediaUrl(editData.url),
  });
  const [previewData, setPreviewData] = useState({
    previewVisible: false,
  });

  const onValuesChange = (value, allValues) => {
    // console.log("values", value);
    // console.log("allValues", allValues);
  };

  const onSaveIndividual = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    await uploadMedia({
      uuid: "0",
      data: formData,
      group: "_default",
    }).catch((err) => {
      console.error("err", err);
      notification["warning"]({
        message: t("Warning"),
        description: t("Media upload problem: ") + err.message,
        placement: "topRight",
      });
      setConfirmLoading(false);
    });
    console.log("on save individual completed: ", file);
    if (onUploadNew !== null) {
      onUploadNew(file);
    }
    setConfirmLoading(false);
    setRefreshData(true);
  };

  const onFinish = async (values) => {
    // This is update, dont need to add files here
    console.log("on finish: ", values);
    const formData = new FormData();
    formData.append("label", values.label);

    await uploadMedia({
      uuid: editData.uuid,
      data: formData,
      group: editData.group,
    }).catch((err) => {
      console.error("err", err);
      notification["warning"]({
        message: t("Warning"),
        description: t("Media upload problem: ") + err.message,
        placement: "topRight",
      });
      setEditData({
        content_type: "image",
        group: "_default",
        uuid: "0",
      });
      setConfirmLoading(false);
      setVisibleEdit(false);
    });

    setConfirmLoading(false);
    setVisibleEdit(false);
    setRefreshData(true);
  };

  const customRequest = ({ file, onSuccess }) => {
    onSuccess("ok");
  };

  const draggerProps = {
    accept,
    name: "file",
    maxCount: 20,
    showUploadList: false,
    multiple: true,
    action: null,
    listType: "picture",
    defaultFileList: editData.uuid === "0" ? [] : [file],
    customRequest,
    onChange(info) {
      const { status } = info.file;
      const files = [];
      if (status !== "uploading") {
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
        const file = info.file.originFileObj;
        onSaveIndividual(file);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
      const list = info.fileList;
      if (list && list.length > 0) {
        list.forEach((file) => {
          if (file.originFileObj) {
            files.push(file.originFileObj);
          }
        });
        form.setFieldsValue({
          files: files,
        });
      }
    },
    onPreview(file) {
      setPreviewData({
        previewVisible: true,
      });
    },
  };

  const onSave = (data) => {
    setConfirmLoading(true);
    form.submit();
  };

  const currentGroup = _.get(editData, "group", 0);
  const currentType = _.get(editData, "content_type", "");
  //use label, when data is empty
  const getInitialValues = () => {
    const values = {
      label: editData.label,
    };
    return values;
  };

  useEffect(() => {
    if (editData && editData.url) {
      form.setFieldsValue({
        label: editData.label,
      });
    }
  }, [editData]);
  return (
    <div style={{ width: "95%", height: 200, marginBottom: 50 }}>
      <Dragger {...draggerProps}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibit from uploading
          company data or other band files
        </p>
      </Dragger>
      {visibleEdit && (
        <Modal
          title="Media edit"
          style={{ top: 20 }}
          open={visibleEdit}
          okText={"Save"}
          confirmLoading={confirmLoading}
          onOk={() => {
            onSave();
          }}
          onCancel={() => {
            setEditData({
              content_type: "image",
              group: "_default",
              uuid: "0",
            });
            setVisibleEdit(false);
          }}
          maskClosable={false}
          width={1000}
          height={700}
          className={"media-edit-form"}
        >
          <Form
            validateMessages={validateMessages}
            layout={"horizontal"}
            form={form}
            initialValues={getInitialValues()}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
          >
            <Form.Item hidden={true} key={"files"} name={"files"} rules={[]}>
              <Input />
            </Form.Item>

            {_.map(
              _.get(
                apiSetup,
                `mediaLibrary.groups.${currentType}.${currentGroup}.fields`,
                [],
              ),
              (item, key) => {
                return (
                  <Form.Item
                    key={item.name}
                    label={item.label}
                    name={item.name}
                    rules={[]}
                  >
                    <Input placeholder={item.label} />
                  </Form.Item>
                );
              },
            )}
          </Form>
        </Modal>
      )}
    </div>
  );
};
